import axios from '@/core/axios';

import { User, UsersList, UsersListOptions, ChangePasswordOptions } from './users.types';

export class UsersService {
  list(opts: UsersListOptions = {}): Promise<UsersList> {
    const { filters, pagination, includeDisabled } = opts;
    const params = { ...filters, ...pagination, ...(includeDisabled ? { include_disabled: true } : {}) };
    return axios.get<UsersList>(`/users`, { params }).then(resp => resp?.data);
  }

  get(userId: number): Promise<User> {
    return axios.get<User>(`/users/${userId}`).then(resp => resp?.data);
  }

  changePassword(userId: string, params: ChangePasswordOptions): Promise<User> {
    return axios.post<User>(`/users/${userId}/change_password`, params).then(resp => resp?.data);
  }

  getAuthenticatedUser(): Promise<User> {
    return axios.get('/user').then(resp => resp?.data);
  }

  addRole(userId: number | string, name: string): Promise<User> {
    return axios.post<User>(`/users/${userId}/roles`, { name }).then(resp => resp?.data);
  }

  removeRole(userId: number | string, roleName: string): Promise<User> {
    return axios.delete<User>(`/users/${userId}/roles/${encodeURIComponent(roleName)}`).then(resp => resp?.data);
  }

  disable(userId: number | string): Promise<User> {
    return axios.post<User>(`/users/${userId}/disable`).then(resp => resp?.data);
  }

  enable(userId: number | string): Promise<User> {
    return axios.post<User>(`/users/${userId}/enable`).then(resp => resp?.data);
  }
}

export const usersService = new UsersService();
